var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M10.074 29.502a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V10.957c0-1.29 1.053-2.33 2.346-2.33h5.31a2.338 2.338 0 0 1 2.344 2.33v18.545zm-2-18.545c0-.18-.153-.33-.345-.33H2.42a.34.34 0 0 0-.345.33v17.545h6V10.957zM33 29.502a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-10.78c0-.79.642-1.427 1.43-1.427h7.14c.788 0 1.43.637 1.43 1.427v10.78zm-2-10.207h-6v9.207h6v-9.207zM21 29.502a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V2.392A2.34 2.34 0 0 1 13.346.058h5.308A2.34 2.34 0 0 1 21 2.39v27.111zm-2-27.11a.34.34 0 0 0-.346-.333h-5.308A.34.34 0 0 0 13 2.39v26.111h6V2.392z"
  })))));
};
export default SvgAnalytics;